import React, { createContext, useContext, useState, ReactNode } from "react";
import { useSelector } from "react-redux";
import { IUserInfo } from "../../store/actions";

interface ChassisContextProps {
  chassisNo: string;
  setChassisNo: (chassisNo: string) => void;
  canAutoSetChassisNo: boolean;
}

const ChassisContext = createContext<ChassisContextProps | undefined>(
  undefined
);

export const ChassisProvider = ({ children }: { children: ReactNode }) => {
  const authInfo: IUserInfo | undefined = useSelector(
    (state: any) => state.userAuthInfoState
  );

  const canAutoSetChassisNo =
    !!authInfo?.roles?.length &&
    (authInfo.roles.includes("quality-assurance") ||
      authInfo.roles.includes("line-manager-qc"));

  const [chassisNo, setChassisNo] = useState<string>(
    canAutoSetChassisNo ? "" : ""
  );

  return (
    <ChassisContext.Provider
      value={{ chassisNo, setChassisNo, canAutoSetChassisNo }}
    >
      {children}
    </ChassisContext.Provider>
  );
};

export const useChassis = () => {
  const context = useContext(ChassisContext);
  if (!context) {
    throw new Error("useChassis must be used within a ChassisProvider");
  }
  return context;
};
